import { Button, Row, Col } from 'react-bootstrap';

interface PageHeaderProps {
  readonly title: string;
  readonly onCreateNew: () => void;
  readonly onCSVUpload: () => void;
}

export const PageHeader = ({ title, onCreateNew, onCSVUpload }: PageHeaderProps) => (
  <Row className="mb-4">
    <Col>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="mb-0" style={{ color: '#000000', fontSize: '28px', fontWeight: 600 }}>
          {title}
        </h1>
        <div className="d-flex gap-2">
          <Button variant="outline-primary" onClick={onCSVUpload}>
            Upload CSV
          </Button>
          <Button variant="primary" onClick={onCreateNew}>
            Create New Ingredient
          </Button>
        </div>
      </div>
    </Col>
  </Row>
);
